import { Row, Col } from "antd";

import styles from "./styles.module.scss";
import { useResponsiveQuery } from "utils";

const CookiePolicy = ({
	data,
	communityName,
}: {
	data?: any;
	communityName?: string;
}) => {
	const { isMobile } = useResponsiveQuery();

	return (
		<div className={styles.content}>
			<div className={styles.title}>
				{communityName ? communityName : "UGENIE"}
			</div>
			<div className={styles.subTitle}>PLATFORM COOKIE POLICY</div>
			{data ? (
				<Row className={styles.row}>
					<Col span={24} className={styles.normal}>
						<div dangerouslySetInnerHTML={{ __html: data }} />
					</Col>
				</Row>
			) : (
				<>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							1
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							Introduction
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.1
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							These terms and conditions govern your use of our
							website,{" "}
							<a
								href="https://www.ugenie.io"
								target="_blank"
								rel="noreferrer"
							>
								www.ugenie.io
							</a>
							, any associated websites, mobile applications,
							white-labelled subdomains or branded platforms
							operated on behalf of our customers, and the
							services provided through them (together, the
							“Platform”).
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.2
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							The term “we” refers to Ugenie Ltd, the owner and
							operator of the Platform, whose registered office is
							at 5 Gunnersbury Crescent, London, W39AA and whose
							company registration number is 09966790 (“us” and
							“our” will be construed accordingly).
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.3
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							The term “you” refers to the user or viewer of our
							Platform, including any member of a community
							created through the Ugenie app or any white-labelled
							version of the Platform operated on behalf of a
							Ugenie customer (a “Community”).
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.4
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							By continuing to use our Platform, you agree to
							these terms and conditions. If you disagree with any
							part of these terms, you must not use the Platform.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.5
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Our Platform uses cookies and similar tracking
							technologies. We will request your explicit consent
							before placing any non-essential cookies on your
							device. You can manage your cookie preferences at
							any time via our Cookie Settings tool or through
							your browser settings.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal}>
							1.6
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							You must be at least 18 years of age to use our
							Platform. The Platform is not intended for users
							under 18. We encourage parents to supervise their
							children’s online activities and to use appropriate
							parental control tools.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							2
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							What are cookies?
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal} />
						<Col xs={21} sm={22} className={styles.normal}>
							Cookies are small text files stored on your device
							when you visit a website. They are used to ensure
							the Platform functions properly and to collect
							information to improve your experience.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							3
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							Types of cookies we use
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal} />
						<Col xs={21} sm={22} className={styles.normal}>
							Essential
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Purpose: Required for core functionality and
							security
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Example Cookie Names: session_id
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Duration: Session
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							First/Third Party: First-party
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal} />
						<Col xs={21} sm={22} className={styles.normal}>
							Analytics
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Purpose: Help us understand usage and improve
							performance
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Example Cookie Names: _ga, _gid
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Duration: 1 day – 2 years
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							First/Third Party: Third-party
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.normal} />
						<Col xs={21} sm={22} className={styles.normal}>
							Functionality
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Purpose: Remembers preferences and enhances user
							experience
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Example Cookie Names: language_pref
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							Duration: 1 year
						</Col>
					</Row>
					<Row
						className={styles.row}
						style={{ marginLeft: isMobile ? 45 : 90 }}
					>
						<Col xs={3} sm={2} className={styles.normal}>
							<div className={styles.dot} />
						</Col>
						<Col xs={21} sm={22} className={styles.normal}>
							First/Third Party: First-party
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							4
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							Legal basis for processing
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold} />
						<Col xs={21} sm={22} className={styles.normal}>
							Essential cookies are used based on our legitimate
							interests in operating the Platform securely and
							efficiently. - Analytics and functionality cookies
							are used only where we have your explicit consent.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							5
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							Managing cookies
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold} />
						<Col xs={21} sm={22} className={styles.normal}>
							You can: - Give or withdraw consent using our Cookie
							Banner or Preference Centre. - Adjust your browser
							settings to refuse or delete cookies.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold}>
							6
						</Col>
						<Col xs={21} sm={22} className={styles.bold}>
							Use on white-labelled platforms
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold} />
						<Col xs={21} sm={22} className={styles.normal}>
							When you access a white-labelled version of the
							Platform operated by Ugenie on behalf of a customer,
							cookies and tracking technologies may still be set
							by Ugenie, as the platform infrastructure is
							provided by us. In these cases, this Cookie Policy
							continues to apply. Our customers may additionally
							provide their own privacy or cookie notices;
							however, any cookies controlled by Ugenie will
							always be governed by this policy.
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold} />
						<Col xs={21} sm={22} className={styles.bold}>
							Changes to this policy
						</Col>
					</Row>
					<Row className={styles.row}>
						<Col xs={3} sm={2} className={styles.bold} />
						<Col xs={21} sm={22} className={styles.normal}>
							We may update this Cookie Policy from time to time.
							Material changes will be communicated to you via the
							Platform or email.
						</Col>
					</Row>

					<Row className={styles.row}>
						<Col span={24} className={styles.normal}>
							For further details, please contact us at{" "}
							<a href="mailto:info@ugenie.io">info@ugenie.io</a>.
						</Col>
					</Row>
				</>
			)}
		</div>
	);
};

export default CookiePolicy;
